import { useLayoutNotifications } from '../../hooks/useLayoutNotifications';

/**
 * 알림/미읽음/`/sse/me` 단일 호스트 — headless(렌더 없음). design-20260717 Phase 2-A.
 *
 * AppLayout 레벨에 **1개만** mount 한다. TopBar/StatusBar 등 표시 컴포넌트는 store 를 읽기만 하고
 * SSE 를 소유하지 않는다 → 상단/하단 바 교체와 무관하게 알림 소유자가 항상 1개(설계 R1 차단).
 */
export function LayoutNotificationHost() {
  useLayoutNotifications();
  return null;
}
